module.exports = __webpack_public_path__ + "img/GlobalMaritime_DistressAndSafetySystem.4aa38ee6.jpg";